



import { Component, Prop, Vue } from "vue-property-decorator";
import { InitializeHelper } from "@/helper/initializeHelper";
import { DebugHelper } from "@/helper/debugHelper";
import { Const } from "@/const"
import { LogHelper } from "@/helper/logHelper";
import { Document } from '@/model/document2/document'

@Component({
  components: {
  }
})
export default class Startup extends Vue 
{
    mounted()
    {
        DebugHelper.trace("startup");

        // 初期設定の読み込み
        var applicationState = this.$store.getters.applicationState;
        var productCode = applicationState.startProductCode;
        var paperRotate = applicationState.startPaperRotate;
        var templateId = applicationState.startTemplateId;
        var isKeepRatio = applicationState.startKeepRatio;
        var designRotate = applicationState.startDesignRotate;
        var startPath = applicationState.startPath;

        // 初期設定のリセット
        this.$store.getters.applicationState.startProductCode = "";
        this.$store.getters.applicationState.startPaperRotate = 0;
        this.$store.getters.applicationState.startTemplateId = 0;
        this.$store.getters.applicationState.startKeepRatio = false;
        this.$store.getters.applicationState.startDesignRotate = 0;
        this.$store.getters.applicationState.startPath = "";

        var to : string | null = null;

        if(productCode != "")
        {
            InitializeHelper.createInitializeDocument(productCode, paperRotate, templateId, isKeepRatio, designRotate,
            (document, product, paper, categoryId, hierarchy) =>
            {
                // 初期設定
                this.$store.getters.data.selectedProduct = product;
                this.$store.getters.data.selectedPaper = paper;
                this.$store.getters.data.paperDirection = this.getDirectionFromRotation(paperRotate);
                this.$store.getters.data.selectTemplateCategory(categoryId, hierarchy);

                this.$store.dispatch("setDocument" , document);

                if(templateId > 0)
                {
                    if(document.useInsertion)
                    {
                        to = "/InsertionEditor";
                        this.$store.getters.applicationState.flowMode = 1;
                    }
                    else
                    {
                        to = "/DesignEditor";
                        this.$store.getters.applicationState.flowMode = 0;
                    }
                }
                else
                {
                    to = "/SelectTemplate";
                }
                if(startPath != "") { to = startPath; }

                var logValue = {
                    productId : document.productId,
                    templateId : templateId ? templateId : "",
                    rotate : paperRotate,
                    version : Const.LABELYASAN_TEN_VERSION
                };
                LogHelper.sendLog("10" , logValue);
                
                this.$emit("complete", to);
            },() =>
            {
                DebugHelper.trace("startup error");
                this.$emit("complete", to);
            });
        }
        else
        {
            // 関連付け起動の場合は起動ログは送らない
            if(this.$store.state.openingFile == null)
            {
                //起動時にログを送信する
                var logValue = { version : Const.LABELYASAN_TEN_VERSION };
                LogHelper.sendLog("0" , logValue , true);
            }
            if(startPath != "") { to = startPath; }
            this.$emit("complete", to);
        }
    }

    private getDirectionFromRotation(rotate : number)
    {
        if(rotate == 90) { return 1; }
        else if(rotate == 180) { return 2; }
        else if(rotate == 270) { return 3; }
        return 0;
    }
}
